export  enum PrintStatusEnum{
    Printed  =  19,
    Not_Printed  =  20
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/print-status.enum.ts